module.exports = __webpack_public_path__ + "img/thanks frame.3233a602.svg";